import WapOnly from '@/components/Responsive/WapOnly';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

export interface FormItemProps {
  label: string | ReactNode;
  children: ReactNode;
  reward?: ReactNode;
  onClick?: () => void;
  bordered?: boolean;
  className?: string;
  labelClassName?: string;
  rightActionClassName?: string;
}
const FormItem = ({
  label,
  children,
  reward,
  onClick,
  bordered = true,
  className,
  labelClassName,
  rightActionClassName,
}: FormItemProps) => {
  return (
    <Box
      className={`flex justify-between items-center px-[14px] py-[16px]  ${
        bordered ? 'border-b-[1px] border-[#efefef]' : ''
      } lg:border-b-0  lg:px-0 ${className}`}
      onClick={onClick}
    >
      <Box className={`font-br f14 lg:w-[98px] lg:mr-[41px] lg:flex-shrink-0 ${labelClassName}`}>
        {label}
      </Box>
      <Box className={`flex items-center f14 flex-1 justify-end ${rightActionClassName}`}>
        <WapOnly>{reward}</WapOnly>
        {children}
      </Box>
    </Box>
  );
};

export default FormItem;
